

export const georgeReviewerReviewHinge = {
  _id: 'georgeReviewerReviewHingeId',
  email: 'george@email.com',
  profileReviewId: 'georgeProfileReviewHingeId',
  reviewerProfileId: 'georgeReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review George! This will really help me!',
  profileReviewedFirstName: 'Elaine',
}

export const jerryReviewerReviewBumble = {
  _id: 'jerryReviewerReviewBumbleId',
  email: 'jerry@email.com',
  profileReviewId: 'jerryProfileReviewBumbleId',
  reviewerProfileId: 'jerryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Jerry! This will really help me!',
  profileReviewedFirstName: 'Elaine',
}

export const kramerReviewerReviewTinder = {
  _id: 'kramerReviewerReviewTinderId',
  email: 'kramer@email.com',
  profileReviewId: 'kramerProfileReviewTinderId',
  reviewerProfileId: 'kramerReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Kramer! This will really help me!',
  profileReviewedFirstName: 'Elaine',
}